import { spy } from 'mobx';
export default function attachInitializer(target, property, init) {
  spy(function (_ref) {
    var type = _ref.type,
        store = _ref.object,
        key = _ref.key;
    if (type !== 'add') return;
    if (property && key !== property) return;
    if (!target.isPrototypeOf(store)) return;
    init(store);
  });
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/mobx-decorators/esm/utils/attach-initializer.js
// module id = 1160
// module chunks = 0